import fetch from '../utils/fetch'

export function getshequdianDetail (id) {
  return fetch({
    url: '/shequdian/' + id,
    method: 'get'
  })
}

export function getshequdianSetting () {
  return fetch({
    url: '/shequdian/order/setting',
    method: 'get'
  })
}

export function shequdianSetting (query) {
  return fetch({
    url: '/shequdian/order/setting',
    method: 'post',
    params: query
  })
}
export function shequdianCreate (query) {
  return fetch({
    url: '/shequdian',
    method: 'post',
    params: query
  })
}

export function shequdianUpdate (id, query) {
  return fetch({
    url: '/shequdian/' + id,
    method: 'put',
    params: query
  })
}

export function shequdianDelete (id) {
  return fetch({
    url: '/shequdian/' + id,
    method: 'delete'
  })
}

export function getshequdianList (query) {
  return fetch({
    url: '/shequdian/list',
    method: 'get',
    params: query
  })
}


export function changeStatus (query) {
  return fetch({
    url: '/shequdian/changestatus',
    method: 'post',
    params: query
  })
}

export function changeOpenDeliveryPrice (query) {
  return fetch({
    url: '/shequdian/changeOpenDeliveryPrice',
    method: 'post',
    params: query
  })
}


export function getshequdianOrderTotalList (query) {
  return fetch({
    url: '/shequdian/ordertotal/list',
    method: 'get',
    params: query
  })
}
export function getshequdianOrderList (query) {
  return fetch({
    url: '/shequdian/order/list',
    method: 'get',
    params: query
  })
}

export function orderExport (query) {
  return fetch({
    url: '/shequdian/order/export',
    method: 'GET',
    params: query
  })
}
export function orderExportDianPuTag (query) {
  return fetch({
    url: '/shequdian/orderdianputag/export',
    method: 'GET',
    params: query
  })
}
export function orderExportDianPuCompare (query) {
  return fetch({
    url: '/shequdian/orderdianpucompare/export',
    method: 'GET',
    params: query
  })
}
export function orderDayTotalExport (query) {
  return fetch({
    url: '/shequdian/orderdaytotal/export',
    method: 'GET',
    params: query
  })
}
export function orderTotalExport (query) {
  return fetch({
    url: '/shequdian/ordertotal/export',
    method: 'GET',
    params: query
  })
}
export function orderTotalCaiGouExport (query) {
  return fetch({
    url: '/shequdian/ordercaigou/export',
    method: 'GET',
    params: query
  })
}
export function exportDataGuoShuOrderExport (query) {
  return fetch({
    url: '/shequdian/orderguoshuorder/export',
    method: 'GET',
    params: query
  })
}


export function orderTotalCaiGouExportTag (query) {
  return fetch({
    url: '/shequdian/ordercaigoutag/export',
    method: 'GET',
    params: query
  })
}


export function getshequdianListOfflineOrderBind (query) {
  return fetch({
    url: '/shequdian/listOfflineBindOrder',
    method: 'post',
    params: query
  })
}

export function kaoqinBanciCreate (query) {
  return fetch({
    url: '/kaoqin/banci',
    method: 'post',
    params: query
  })
}

export function kaoqinBanciUpdate (id, query) {
  return fetch({
    url: '/kaoqin/banci/' + id,
    method: 'put',
    params: query
  })
}
export function getKaoqinBanciList (query) {
  return fetch({
    url: '/kaoqin/banci/list',
    method: 'get',
    params: query
  })
}

export function kaoqinBanciDelete (id) {
  return fetch({
    url: '/kaoqin/banci/' + id,
    method: 'delete'
  })
}
export function getkaoqinSetting () {
  return fetch({
    url: '/kaoqin/setting',
    method: 'get'
  })
}

export function kaoqinSetting (query) {
  return fetch({
    url: '/kaoqin/setting',
    method: 'post',
    params: query
  })
}

export function getKaoQinList (query) {
  return fetch({
    url: '/kaoqin/kaoqin/list',
    method: 'get',
    params: query
  })
}
export function getKaoQinReport (query) {
  return fetch({
    url: '/kaoqin/kaoqin/report',
    method: 'get',
    params: query
  })
}

export function exportKaoQin (query) {
  return fetch({
    url: '/kaoqin/kaoqin/export',
    method: 'GET',
    params: query
  })
}

export function kaoqinWifiCreate (query) {
  return fetch({
    url: '/kaoqin/wifi',
    method: 'post',
    params: query
  })
}

export function kaoqinWifiUpdate (id, query) {
  return fetch({
    url: '/kaoqin/wifi/' + id,
    method: 'put',
    params: query
  })
}
export function getKaoqinWifiList (query) {
  return fetch({
    url: '/kaoqin/wifi/list',
    method: 'get',
    params: query
  })
}

export function kaoqinWifiDelete (id) {
  return fetch({
    url: '/kaoqin/wifi/' + id,
    method: 'delete'
  })
}

export function getGuoshuReport (query) {
  return fetch({
    url: '/shequdian/orderguoshuorder/edit',
    method: 'get',
    params: query
  })
}
export function saveGuoshu (query) {
  return fetch({
    url: '/shequdian/orderguoshuorder/save',
    method: 'post',
    params: query
  })
}
export function saveGuoshuTotal (query) {
  return fetch({
    url: '/shequdian/orderguoshuorder/savetotal',
    method: 'post',
    params: query
  })
}
export function yudingCreate (query) {
  return fetch({
    url: '/shequdian/orderguoshuorder/createtotalyuding',
    method: 'post',
    params: query
  })
}
export function getCurrentOrder (query) {
  return fetch({
    url: '/shequdian/orderguoshuorder/getcurrentyuding',
    method: 'get',
    params: query
  })
}

